module.exports = __webpack_public_path__ + "img/colored-paper-1.f14d610d.png";